import { Card } from "@/components/ui/card";
import TaxGroupTableView from "./table";
import useDocumentTitle from "@/components/ui/common/document-title";


const TaxGroup = () => {
  useDocumentTitle("Tax Group");
  
  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <TaxGroupTableView />
      </Card>
    </div>
  );
};

export default TaxGroup;
